import { Error, Gap, Button, Box } from '@salecycle/ui-component-library';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Actions as Router } from 'router';

const Container = styled.div``;

interface DispatchProps {
  push: (href: string) => void;
}

function DefaultErrorPage(props: DispatchProps) {
  const { t } = useTranslation('error');
  return (
    <Container>
      <Box stackItems={true}>
        <Gap top={50} />
        <Error heading={t('default.heading')} />
        <Box horizontalPositioning="center">
          <Button
            variation="secondary"
            onClick={() => {
              props.push('/');
            }}
          >
            {t('default.gotoDashboardButton.label')}
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

const actions: DispatchProps = {
  push: Router.push,
};

export default connect(null, actions)(DefaultErrorPage);
